<div class="row d-flex justify-content-end container-style px-2 py-1">
  <div class="col-auto pt-1 pb-1">
    <app-custom-button [title]="'Nuevo Registro'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
      [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="newRegister()"></app-custom-button>
    <app-custom-modal #registerModal [label]="'Captura Período Inventario'" [header]="'Captura Período Inventario'"
      [width]="'35rem'" [inputs$]="inputsForRegisterModals$" [children]="componentRegisterInventoryPeriod"
      [output$]="output$" hidden></app-custom-modal>
  </div>
</div>
<div class="container-style mt-2" *ngIf="!isOpened">
  <app-custom-table [showExport]="true" [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [filterPersistentKey]="url" (onRecoverData)="getAllInventoryPeriodsWithPagination()"
    (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
    (onAction)="onAction($event)">
  </app-custom-table>
</div>
<app-custom-modal #documentsOpenedModal [header]="'Documentos Pendientes'" [width]="'50rem'"
  [children]="componentDocumentsOpened" [inputs$]="inputsForDocumentsOpenedModal$" [output$]="output$"
  (onRecoverData)="getAllDocuments()" hidden>
</app-custom-modal>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>